import User from '@/api/security/user'
import Role from '@/api/security/role'
import Company from '@/api/administration/company'
import Branch from '@/api/administration/branches'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  roles: [],
  companies: [],
  branches: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_ROLES(state, roles) {
    state.roles = roles
  },
  RECEIVE_COMPANIES(state, companies) {
    state.companies = companies
  },
  RECEIVE_BRANCHES(state, branches) {
    state.branches = branches
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return User.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return User.store(data)
  },

  update(context, { id, ...data }) {
    return User.update(id, {
      ...data,
      user_name: undefined,
      password: undefined,
      password_confirmation: undefined
    })
  },

  destroy(context, id) {
    return User.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  changePassword(context, { id, new_password, new_password_confirmation }) {
    return User.changePassword(id, {
      new_password,
      new_password_confirmation
    })
  },

  fetchRoles(context) {
    if (context.state.roles.length > 0) return

    return Role.get({ params: { page: -1 } }).then(response => {
      context.commit('RECEIVE_ROLES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchCompanies(context) {
    if (context.state.companies.length > 0) return

    return Company.get({
      params: { page: -1 },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECEIVE_COMPANIES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchBranches(context) {
    if (context.state.branches.length > 0) return

    return Branch.get({
      params: { page: -1 },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECEIVE_BRANCHES', response.data)
      return Promise.resolve(response)
    })
  }
}
